import { TProviderApi } from "@/types/Provider.types";
import { useInfinitePagination } from "../useInfinitePagination";
import { getProviders } from "@/services/api/requests/providers";
import { INFINITE_SCROLL_CARDS_PER_PAGE } from "@/constants";
import queryKeys from "@/constants/queryKeys";
import { useAppStore } from "@/store/useAppStore";

const useMYOProviderDirectory = (itemsPerPage?: number, starredFirst = false) => {
  const { user } = useAppStore();

  return useInfinitePagination<TProviderApi[]>({
    query: (page, limit) => getProviders(page, limit, starredFirst),
    queryKey: [queryKeys.providers.directory, user?.email ?? '', String(starredFirst)],
    limit: itemsPerPage ?? INFINITE_SCROLL_CARDS_PER_PAGE,
    getId: (provider) => provider._id,
  });
};

export default useMYOProviderDirectory;
